const gallery = [
    {
        key: 1,
        name: "architect-top-img",
        imgURL: "pexels-laura-paredis-13517794.jpg",
        alt: "architect"
    },
    {
        key: 2,
        name: "archi-background",
        imgURL: "pexels-laura-paredis-13517796.jpg",
        alt: "background image"
    },
    {
        key: 3,
        name: "archi-background",
        imgURL: "pexels-phearak-chamrien-13507215.jpg",
        alt: "background image"
    },
    {
        key: 4,
        name: "archi-background",
        imgURL: "pexels-şeyma-d-13508900.jpg",
        alt: "background image"
    },
    {
        key: 5,
        name: "archi-background",
        imgURL: "pexels-skyler-ewing-13424600.jpg",
        alt: "background image"
    },
    {
        key: 6,
        name: "archi-background",
        imgURL: "pexels-wallace-silva-10654421.jpg",
        alt: "background image"
    },
];

export default gallery;